import * as R from 'ramda';
import { ActionType } from '../../core/redux/actionType';
import { ApiReducer, makeApiAction, makeApiReducer, makeRsaaTypes } from '../../core/api/rsaa';
import { addError, addLoading, noLoadingNoError, getLoading } from '../../core/api/module';
import { Endpoints } from '../../core/api/endpoints';
import { AppState } from '../../core/redux/appState';


const KEY_ACTION = ActionType.ReportDataRequest;
const ACTIONS    = [
  ActionType.ReportDataRequest,
  ActionType.ReportDataResponse,
  ActionType.ReportDataError,
];


type Payload = Uint8Array;


type Meta = {
  file: string;
};


/**
 * Dispatch this to retrieve file data for report
 *
 * @param file - the file to return
 */
export const reportDataAction = (
  file: string,
) => makeApiAction<Payload, Meta>(
  {
    method:   'POST',
    endpoint: Endpoints.ReportData,
    headers:  { 'content-type': 'application/json',
                'accept': 'application/octet-stream'},
    body:     JSON.stringify({
      file:     file,
    }),
    types:    makeRsaaTypes<Payload, Meta>(ACTIONS, { file }),
    bailout:  (state: AppState) => !!getLoading(state, KEY_ACTION),
  },
);

const reducer: ApiReducer<Payload, Meta> = (state, action, errorMsg, isLoading, payload) => {
  const metaTag = `${action.meta.file}`;

  if (isLoading) {
    return addLoading(state, KEY_ACTION, metaTag);
  }

  if (errorMsg) {
    return addError(state, KEY_ACTION, errorMsg, metaTag);
  }

  const successState = noLoadingNoError(state, KEY_ACTION, metaTag);

//TODO - payload moved into state - need to handle elsewhere or maybe get rid of this action all together

  return R.assoc('reportData', payload, successState);
};

export const reportDataReducer = makeApiReducer<Payload, Meta>(ACTIONS, KEY_ACTION, reducer);
